import React from 'react';
import {
  Card,
  CardHeader,
  CardContent,
  Grid,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Button,
  Collapse,
  Autocomplete,
  TextField,
  CircularProgress,
} from '@mui/material';

function findFilterOption(options, value) {
  if (value === '' || value == null) return null;
  return (options || []).find((option) => String(option?.id) === String(value)) ?? null;
}

function SearchableFilterAutocomplete({
  label,
  options,
  value,
  onChange,
  onOpen,
  loading = false,
  noOptionsText = 'No options found',
}) {
  return (
    <Autocomplete
      fullWidth
      options={Array.isArray(options) ? options : []}
      value={findFilterOption(options, value)}
      onChange={(_, selected) => onChange(selected?.id ?? '')}
      onOpen={() => {
        if (typeof onOpen === 'function') onOpen();
      }}
      loading={loading}
      getOptionLabel={(option) => option?.name || ''}
      isOptionEqualToValue={(option, selected) =>
        String(option?.id) === String(selected?.id)
      }
      renderInput={(params) => (
        <TextField
          {...params}
          label={label}
          InputProps={{
            ...params.InputProps,
            endAdornment: (
              <>
                {loading ? <CircularProgress color="inherit" size={18} /> : null}
                {params.InputProps.endAdornment}
              </>
            ),
          }}
        />
      )}
      noOptionsText={loading ? 'Loading…' : noOptionsText}
    />
  );
}

const ImportBusinessFilters = ({
  showFilters,
  filters,
  sort,
  statusOptions = [],
  categoryOptions = [],
  stateOptions = [],
  statusFilterLoading = false,
  categoryFilterLoading = false,
  stateFilterLoading = false,
  onStatusOpen,
  onCategoryOpen,
  onStateOpen,
  onFilterChange,
  onSortChange,
  onClearFilters,
}) => {
  return (
    <Collapse in={showFilters}>
      <Card sx={{ mb: 3 }}>
        <CardHeader
          title="Filters & Sorting"
          action={
            <Button onClick={onClearFilters} color="primary">
              Clear All
            </Button>
          }
        />
        <CardContent>
          <Grid container spacing={3}>
            <Grid item xs={12} md={3}>
              <FormControl fullWidth>
                <SearchableFilterAutocomplete
                  label="Status"
                  options={statusOptions}
                  value={filters.status_id}
                  onChange={(next) => onFilterChange('status_id', next)}
                  onOpen={onStatusOpen}
                  loading={statusFilterLoading}
                  noOptionsText="No status found"
                />
              </FormControl>
            </Grid>

            <Grid item xs={12} md={3}>
              <FormControl fullWidth>
                <SearchableFilterAutocomplete
                  label="Category"
                  options={categoryOptions}
                  value={filters.business_category_id}
                  onChange={(next) => onFilterChange('business_category_id', next)}
                  onOpen={onCategoryOpen}
                  loading={categoryFilterLoading}
                  noOptionsText="No category found"
                />
              </FormControl>
            </Grid>

            <Grid item xs={12} md={3}>
              <FormControl fullWidth>
                <SearchableFilterAutocomplete
                  label="State"
                  options={stateOptions}
                  value={filters.state_id}
                  onChange={(next) => onFilterChange('state_id', next)}
                  onOpen={onStateOpen}
                  loading={stateFilterLoading}
                  noOptionsText="No state found"
                />
              </FormControl>
            </Grid>

            <Grid item xs={12} md={6}>
              <FormControl fullWidth>
                <InputLabel>Sort By</InputLabel>
                <Select
                  value={sort.sort_by}
                  onChange={(e) => onSortChange({ ...sort, sort_by: e.target.value })}
                  label="Sort By"
                >
                  <MenuItem value="id">ID</MenuItem>
                  <MenuItem value="created_at">Created At</MenuItem>
                  <MenuItem value="name">Name</MenuItem>
                </Select>
              </FormControl>
            </Grid>

            <Grid item xs={12} md={6}>
              <FormControl fullWidth>
                <InputLabel>Sort Direction</InputLabel>
                <Select
                  value={sort.sort_direction}
                  onChange={(e) => onSortChange({ ...sort, sort_direction: e.target.value })}
                  label="Sort Direction"
                >
                  <MenuItem value="desc">Descending</MenuItem>
                  <MenuItem value="asc">Ascending</MenuItem>
                </Select>
              </FormControl>
            </Grid>
          </Grid>
        </CardContent>
      </Card>
    </Collapse>
  );
};

export default ImportBusinessFilters;
